// dropdown list Web hook page get api
export const GET_WEB_HOOKS_PROCESS_LIST = "GET_WEB_HOOKS_PROCESS_LIST"
export const GET_WEB_HOOKS_PROCESS_LIST_SUCCESS = "GET_WEB_HOOKS_PROCESS_LIST_SUCCESS"
export const GET_WEB_HOOKS_PROCESS_LIST_ERROR = "GET_WEB_HOOKS_PROCESS_LIST_ERROR"

// Web hook page get api
export const GET_WEB_HOOKS = "GET_WEB_HOOKS"
export const GET_WEB_HOOKS_SUCCESS = "GET_WEB_HOOKS_SUCCESS"
export const GET_WEB_HOOKS_ERROR = "GET_WEB_HOOKS_ERROR"

// Insert WebHook
export const POST_WEB_HOOKS_INSERT = "POST_WEB_HOOKS_INSERT"
export const POST_WEB_HOOKS_INSERT_SUCCESS = "POST_WEB_HOOKS_INSERT_SUCCESS"
export const POST_WEB_HOOKS_INSERT_ERROR = "POST_WEB_HOOKS_INSERT_ERROR"

// Update WebHook
export const POST_WEB_HOOKS_UPDATE = "POST_WEB_HOOKS_UPDATE"
export const POST_WEB_HOOKS_UPDATE_SUCCESS = "POST_WEB_HOOKS_UPDATE_SUCCESS"
export const POST_WEB_HOOKS_UPDATE_ERROR = "POST_WEB_HOOKS_UPDATE_ERROR"

// Delete WebHook
export const PUT_WEB_HOOKS_DELETE = "PUT_WEB_HOOKS_DELETE"
export const PUT_WEB_HOOKS_DELETE_SUCCESS = "PUT_WEB_HOOKS_DELETE_SUCCESS"
export const PUT_WEB_HOOKS_DELETE_ERROR = "PUT_WEB_HOOKS_DELETE_ERROR"
